import { Header } from '@Components/StickyTable';
import { invoiceMonthLabel } from '@Pages/BillingAutomation/billing-utils';
import { FinanceRow } from './finance-constants';
import { yesNo } from './finance-utils';

export const financeHeaders: Header[] = [
  {
    label: 'CID',
    name: 'cid',
    flex: true,
    minFlexWidth: 140,
    sortPriority: 2,
    sortAscending: true
  },
  {
    label: 'Month',
    name: 'month',
    flex: true,
    minFlexWidth: 120,
    sortPriority: 1,
    sortAscending: false,
    renderer: (row: FinanceRow) => invoiceMonthLabel(row.month)
  },
  { label: 'Salesforce Account', name: 'accountName', flex: true, minFlexWidth: 180 },
  {
    label: 'Salesforce Relationship',
    name: 'salesforceRelationshipName',
    flex: true,
    minFlexWidth: 280
  },
  { label: 'Channel', name: 'channel', flex: true, minFlexWidth: 120 },
  { label: 'Platform', name: 'platform', flex: true, minFlexWidth: 120 },
  { label: 'Billing Category', name: 'billingCategory', flex: true, minFlexWidth: 160 },
  {
    label: 'Metric to Bill',
    name: 'metricToBill',
    flex: true,
    minFlexWidth: 140,
    renderer: (row: FinanceRow) => row.metricToBill.toLocaleString()
  },
  { label: 'Tool Used', name: 'toolUsed', flex: true, minFlexWidth: 120 },
  { label: 'Tool Spend', name: 'toolSpend', flex: true, minFlexWidth: 120 },
  {
    label: 'Billable',
    name: 'billable',
    flex: true,
    minFlexWidth: 100,
    contentGetter: (row: FinanceRow) => yesNo(row.billable),
    renderer: (row: FinanceRow) => yesNo(row.billable)
  },
  { label: 'Include in Fee Calc', name: 'includeInFeeCalc', flex: true, minFlexWidth: 160 },
  { label: 'Signed Off', name: 'signedOff', flex: true, minFlexWidth: 110 },
  { label: 'Signed Off By', name: 'signedOffBy', flex: true, minFlexWidth: 200 }
];
